/**
 * StatsBlock — Web renderer for STATS content blocks.
 *
 * Displays big number callouts (e.g., "$250K Prize Pool", "10,000 Players")
 * in a row or grid layout. Uses hub theme accent for styling.
 */

import { SurfaceStatsConfigResponse } from "@/hooks/hub/useGetHub";
import "./StatsBlock.scss";

interface StatsBlockProps {
    config?: SurfaceStatsConfigResponse;
    sectionTitle?: string;
}

export const StatsBlock = ({ config, sectionTitle }: StatsBlockProps) => {
    const items = config?.items || [];
    if (items.length === 0) return null;

    const layout = config?.layout || "row";
    const columns = Math.max(1, Math.min(config?.columns || 3, 6));

    return (
        <div className="stats-block">
            {sectionTitle && <h2 className="section-title">{sectionTitle}</h2>}
            <div
                className={`stats-block__container stats-block__container--${layout}`}
                style={layout === "grid" ? { gridTemplateColumns: `repeat(${columns}, 1fr)` } : undefined}
            >
                {items.map((item, i) =>
                    <div key={item._id || i} className="stats-block__item">
                        <div className="stats-block__value">
                            {item.prefix && <span className="stats-block__prefix">{item.prefix}</span>}
                            {item.value}
                            {item.suffix && <span className="stats-block__suffix">{item.suffix}</span>}
                        </div>
                        <div className="stats-block__label">{item.label}</div>
                    </div>)}
            </div>
        </div>
    );
};
